module.exports = __webpack_public_path__ + "assets/InternationalInstitutions.46da6326.svg";